export const setPaymentAmount = (data) => ({
    type:"SET_PAYMENT_AMOUNT",
    data
})

export const setPaymentConfigData = (data) => ({
    type:"SET_PAYMENT_CONFIG_DATA",
    data
})

